<template>
  <wrld-container>
    <v-row
      justify="space-between"
    >
        <v-col md="12">
          <NotificationsNewsFeedList/>
        </v-col>
    </v-row>
  </wrld-container>
</template>

<script>
import NotificationsNewsFeedList from '@/components/notifications/NotificationsNewsFeedList.vue'
export default {
  name: 'NotificationsNewsFeed',
  components: {
    NotificationsNewsFeedList
  }
}
</script>

<style>

</style>
